//===================================================//
//    SHUFFLED INK | PRODUCT SINGLE CUSTOMIZATION    //
//===================================================//

(function($) {
	$(document).ready(function() {

		//-- SET VARS --//
		var fadeSpeed		= 1000;
		var content			= $( '#inner-content' );
		var title			= $( '.product_title' );
		var designer		= $( '.fpd-product-designer-wrapper' );
		var dialog			= $( '.fpd-draggable-dialog' );
		var toggler			= $( '.build-or-upload' );
		var uploadRadio		= $( 'input[value="upload"]', toggler );
		var help			= $( '#product-help' );
		var resources		= $( '#product-resources' );
		var replaceDialog	= false;


		//-- CONTENT FADER --//
		function buildUploadFade() {

			content.addClass( 'fade-out' );

			setTimeout( function() {
				content.removeClass( 'fade-out' );
			}, fadeSpeed );
		}


		//-- DESIGNER/HELPER SWITCHER --//
		function switchDesignerHelper() {

			buildUploadFade();

			setTimeout( function() {
				title.toggleClass( 'upload-your' );
				designer.toggleClass( 'hidden' );
				help.toggleClass( 'visible' );
				resources.toggleClass( 'hidden' );
				toggleDialog();
			}, fadeSpeed / 2 );
		}


		//-- SHOW/HIDE FPD DIALOG --//
		function toggleDialog() {

			dialog = $( '.fpd-draggable-dialog' );

			if ( dialog.hasClass( 'fpd-active' ) ) {
				dialog.removeClass( 'fpd-active' );
				replaceDialog = true;
			}
			else if ( replaceDialog === true ) {
				dialog.addClass( 'fpd-active' );
				replaceDialog = false;
			}
		}


		//-- BUILD/UPLOAD TOGGLE --//
		toggler.change( function(){
			switchDesignerHelper();
		});


		//-- NO FPD ON THIS PRODUCT --//
		if ( ! designer.length ) {
			switchDesignerHelper();
			help.addClass( 'no-designer' );
		}


		//-- UPLOAD SELECTED ON LOAD --//
		if ( uploadRadio.is( ':checked' ) ) {

			// "Upload Your"
			title.addClass( 'upload-your' );

			// Hide Fancy Product Designer
			designer.addClass( 'hidden' );

			// Show product help
			help.addClass( 'visible' );

			// Show product resources
			resources.addClass( 'hidden' );
		}

	}); // document.ready
})(jQuery);
